// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 700px;
}
:host .property-container {
  width: 300px;
}
:host .item-block {
  display: block;
}
:host .item-block mat-select, :host .item-block input, :host .item-block span {
  width: calc(100% - 7px);
}
:host .slider-field span {
  padding-left: 2px;
  text-overflow: clip;
  max-width: 125px;
  white-space: nowrap;
  overflow: hidden;
}
:host .slider-field mat-slider {
  background-color: var(--formSliderBackground);
  height: 30px;
}
:host .toolbox {
  float: right;
  line-height: 44px;
}
:host .toolbox button {
  /* margin-right: 8px; */
  margin-left: 10px;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
}
:host .mat-tab-container {
  min-height: 300px;
  height: 60vmin;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/view-property/view-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/view-property/view-property.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;ACAR;ADGI;EACI,YAAA;ACDR;ADII;EACI,cAAA;ACFR;ADGQ;EACI,uBAAA;ACDZ;ADKI;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACHR;ADMI;EACI,6CAAA;EACA,YAAA;ACJR;ADOI;EACI,YAAA;EACA,iBAAA;ACLR;ADQI;EACI,uBAAA;EACA,iBAAA;ACNR;ADSI;EACI,uBAAA;ACPR;ADUI;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ACRR","sourcesContent":[":host {\n    .container {\n        width: 700px;\n    }\n\n    .property-container {\n        width: 300px;\n    }\n\n    .item-block {\n        display: block;\n        mat-select, input, span {\n            width: calc(100% - 7px);\n        }\n    }\n\n    .slider-field span {\n        padding-left: 2px;\n        text-overflow: clip;\n        max-width: 125px;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .slider-field mat-slider {\n        background-color: var(--formSliderBackground);\n        height: 30px;\n    }\n\n    .toolbox {\n        float: right;\n        line-height: 44px;\n    }\n\n    .toolbox button {\n        /* margin-right: 8px; */\n        margin-left: 10px;\n    }\n\n    ::ng-deep .mat-tab-label {\n        height: 34px !important;\n    }\n\n    .mat-tab-container {\n        min-height:300px;\n        height: 60vmin;\n        overflow-y: auto;\n        overflow-x: hidden;\n        padding-top: 15px;\n    }\n}\n",":host .container {\n  width: 700px;\n}\n:host .property-container {\n  width: 300px;\n}\n:host .item-block {\n  display: block;\n}\n:host .item-block mat-select, :host .item-block input, :host .item-block span {\n  width: calc(100% - 7px);\n}\n:host .slider-field span {\n  padding-left: 2px;\n  text-overflow: clip;\n  max-width: 125px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n:host .slider-field mat-slider {\n  background-color: var(--formSliderBackground);\n  height: 30px;\n}\n:host .toolbox {\n  float: right;\n  line-height: 44px;\n}\n:host .toolbox button {\n  /* margin-right: 8px; */\n  margin-left: 10px;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n}\n:host .mat-tab-container {\n  min-height: 300px;\n  height: 60vmin;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-top: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
